import { useEffect, useState } from "react";
import { Button, Card, Spinner } from "flowbite-react";
import { supabase } from "../../lib/supabase";
import { useNavigate } from "react-router-dom";
import { HiCheckCircle, HiXCircle } from "react-icons/hi";

const VerifyPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const verifyOtp = async () => {
      try {
        // Get the OTP from the URL
        const hash = window.location.hash;

        if (!hash) {
          setError("Invalid verification link");
          setLoading(false);
          return;
        }

        // Verify the OTP
        const { error: verifyError } = await supabase.auth.verifyOtp({
          type: "magiclink",
          token_hash: hash.substring(1),
        });

        if (verifyError) {
          throw verifyError;
        }

        // Set user as verified
        setSuccess(true);

        // Redirect to dashboard after 2 seconds
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } catch (err) {
        setError(err instanceof Error ? err.message : "Verification failed");
      } finally {
        setLoading(false);
      }
    };

    verifyOtp();
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 p-4 dark:bg-gray-900">
      <Card className="max-w-md">
        <div className="flex flex-col items-center p-6 text-center">
          <h1 className="mb-4 text-2xl font-bold">Account Verification</h1>

          {loading && (
            <div className="flex flex-col items-center space-y-4">
              <Spinner size="xl" />
              <p className="text-gray-500 dark:text-gray-400">
                Verifying your account...
              </p>
            </div>
          )}

          {error && (
            <div className="mt-4 text-center">
              <div className="mb-4 flex justify-center">
                <HiXCircle className="h-16 w-16 text-red-500" />
              </div>
              <h2 className="mb-2 text-xl font-semibold text-red-800">
                Verification Failed
              </h2>
              <p className="mb-4 text-gray-700 dark:text-gray-400">{error}</p>
              <Button color="failure" onClick={() => navigate("/login")}>
                Back to Login
              </Button>
            </div>
          )}

          {success && (
            <div className="mt-4 text-center">
              <div className="mb-4 flex justify-center">
                <HiCheckCircle className="h-16 w-16 text-green-500" />
              </div>
              <h2 className="mb-2 text-xl font-semibold text-green-800">
                Verification Successful
              </h2>
              <p className="mb-4 text-gray-700 dark:text-gray-400">
                Your account has been verified successfully. You will be
                redirected to the dashboard.
              </p>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};

export default VerifyPage;
